import { render, staticRenderFns } from "./StockTrfDetails.vue?vue&type=template&id=6de2f1b5&"
import script from "./StockTrfDetails.vue?vue&type=script&lang=js&"
export * from "./StockTrfDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports